import authInstance from "../Interceptor";

export const customerReportEffect = (pageNo) => {
  return authInstance.get(
    `/reports/getallcustomerswithreports?pageNo=${pageNo}&pagesize =10&pagination_required=true`
  );
};

export const CustomerDateSearchReportEffect = ({
  pageNo,
  start_date,
  end_date,
}) => {
  return authInstance.get(
    `/reports/getallcustomerswithreports?pageNo=${pageNo}&pagesize=10&pagination_required=true&start_date=${start_date}&end_date=${end_date}`
  );
};
